// extracted by mini-css-extract-plugin
export var addButton = "_mz-0";
export var border = "_mz-8";
export var check = "_mz-h";
export var danger = "_mz-6";
export var dropdownContainer = "_mz-1";
export var editModalBody = "_mz-j";
export var footerContainer = "_mz-i";
export var fullWidth = "_mz-a";
export var hide = "_mz-9";
export var icon = "_mz-3";
export var input = "_mz-7";
export var inputFlex = "_mz-b";
export var inputWrapper = "_mz-c";
export var manualFocus = "_mz-5";
export var optionButton = "_mz-4";
export var pillWrapper = "_mz-e";
export var pointer = "_mz-2";
export var showOverflow = "_mz-f";
export var tagsFlex = "_mz-d";
export var xButton = "_mz-g";